import Layout from '../views/layout/App.vue'
export default {
  path: '/org_manage',
  name: 'OrgManage',
  meta: {
    title: '机构管理',
    isAdmin: true
  },
  component: Layout,
  redirect: '/org_manage/org_list',
  children: [
    {
      path: 'org_list',
      name: 'OrgList',
      meta: {
        title: '机构列表',
        isAdmin: true
      },
      component: resolve => require(['@/views/orgMangage/orgList/Index.vue'], resolve),
    },
  ]
}
